var _desc, _defs, _g, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maybe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maybe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-191-+-Stroke-192",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#FDBB48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,18 C36,27.9392727 27.9392727,36 18,36 C8.05745455,36 0,27.9392727 0,18 C0,8.05745455 8.05745455,0 18,0 C27.9392727,0 36,8.05745455 36,18 L36,18 Z",
    id: "Stroke-191",
    className: "cqqfPRYM_0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,19 L28,19",
    id: "Stroke-192",
    className: "cqqfPRYM_1"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".cqqfPRYM_0{stroke-dasharray:114 116;stroke-dashoffset:115;animation:cqqfPRYM_draw 1014ms ease-in-out 0ms forwards;}.cqqfPRYM_1{stroke-dasharray:20 22;stroke-dashoffset:21;animation:cqqfPRYM_draw 185ms ease-in-out 1014ms forwards;}@keyframes cqqfPRYM_draw{100%{stroke-dashoffset:0;}}@keyframes cqqfPRYM_fade{0%{stroke-opacity:1;}92.5925925925926%{stroke-opacity:1;}100%{stroke-opacity:0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionAnimated);
export default __webpack_public_path__ + "static/media/inspection_animated.09869dd20bd82619e69e1dabf9fa96b2.svg";
export { ForwardRef as ReactComponent };